export default function Runescape() {

    return (
        <div className="mt-5 col-12 col-md-4">
            <div className="full-height align-center">
                <div className="p-3 grey-3 index-card-background-full">
                    <img
                        src={process.env.PUBLIC_URL + "/images/gaming/runescapeIcon.png"}
                        className="index-card-icon"
                        alt="runescapeIcon"
                    />
                    <div className="index-card-header">Old School Runescape</div>
                    <div className="left">
                    I have spend around 6900hr logged into OSRS to reach a max lvl account. (Pre-Sailing)
            Most of the time I am doing other activites while playing. I am now working on an Ironman account.
                    </div>
                    <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                    <a href="https://secure.runescape.com/m=hiscore_oldschool/hiscorepersonal.ws?user1=ChippyCheese"><img
                        src={process.env.PUBLIC_URL + "/images/gaming/osrsStats.png"}
                        className="league-stat-icon"
                        alt="Chippy Cheese"
                    /></a>
                    <a href="https://secure.runescape.com/m=hiscore_oldschool/hiscorepersonal.ws?user1=JasperCheese"><img
                        src={process.env.PUBLIC_URL + "/images/gaming/osrsIronman.png"}
                        className="league-stat-icon"
                        alt="Jasper Cheese"
                    /></a></div>
                </div>                
            </div>
        </div>
    );
}